import React from 'react';
import { TagVocabItem } from '../api/UserTagsAPI';

// Shared state for user-selected pattern tags within one game's review view. Loaded once by
// UserTagsProvider (the game's current tags + the controlled vocabulary) and consumed by the
// move-scope picker in the move panel and the game-scope picker in the game body.
export type UserTagsContextValue = {
  vocabulary: TagVocabItem[];
  // Move tags keyed by move Pgn, and the whole-game tags.
  moveTags: Record<string, string[]>;
  gameTags: string[];
  toggleMoveTag: (pgn: string, theme: string) => void;
  toggleGameTag: (theme: string) => void;
};

const UserTagsContext = React.createContext<UserTagsContextValue>({
  vocabulary: [],
  moveTags: {},
  gameTags: [],
  toggleMoveTag: () => undefined,
  toggleGameTag: () => undefined,
});

export default UserTagsContext;
